// extracted by mini-css-extract-plugin
export default {"menuListItem":"styles_menuListItem__kgjh9","menuListIcon":"styles_menuListIcon__fNn2B"};